module.exports = __webpack_public_path__ + "static/img/mediaReportTwo.967fefc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mediaReportTwo.png
// module id = srLQ
// module chunks = 1